'use strict';

/**
 * LocationFinder
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.LocationFinder = T.createModule({

	_selectors: {
		addresses: '[data-js-o-location-finder__address]',
		button: '[data-js-o-location-finder__button]',
		resultCount: '[data-js-o-location-finder__result-count]',
		resultText: '[data-js-o-location-finder__result-text]'
	},

	_eventNames: {
		// Search as you type functionality of the filter
		filterChange: 'm-filter-change',
		searchClosed: 'm-filter-search-closed',
		filterMapData: 'm-filter-map-data'
	},

	_addressFields: ['name', 'address', 'addressLine2', 'postalBox', 'postalCode', 'city', 'country', 'phone', 'phoneSecond', 'fax', 'mail', 'map', 'more'],

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$addresses = this.$ctx.find(this._selectors.addresses);
		this.$button = this.$ctx.find(this._selectors.button);
		this.$resultCount = this.$ctx.find(this._selectors.resultCount);
		this.$resultText = this.$ctx.find(this._selectors.resultText);

		this.resultTextSingular = this.$resultText.data('result-text-singular');
		this.resultTextPlural = this.$resultText.data('result-text-plural');

		this.initialVisibleItems = 9;
		this.loadMoreItems = 9;

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		this._events.on(this._eventNames.filterChange, this.onFilterChange.bind(this));
		this._events.on(this._eventNames.searchClosed, this.onSearchClosed.bind(this));

		// Component Event Binding
		this.$button.on('click', this.onClickMoreButton.bind(this));

		this.hasBeenInitialized = false;

		resolve();
	},
	sync: function sync() {
		if (!this.hasBeenInitialized) {
			this.showInitialSelection();
			this.generateLunrIndex();

			this.hasBeenInitialized = true;
		}
	},


	/**
  * Generate the lunr index for searching
  *
  * @returns {void}
  */
	generateLunrIndex: function generateLunrIndex() {
		var _this2 = this;

		var fields = this._addressFields;

		// add all fields to the lunr index
		this.lunrIndex = lunr(function () {
			var _this = this;

			fields.map(function (field) {
				return _this.field(field);
			});
			return this.ref('id');
		});

		// loop over all addresses to generate the lunr document for every address
		this.$addresses.each(function (index, element) {
			var address = $(element);
			var elementIndexObject = {};

			elementIndexObject.id = address.attr('id');

			fields.map(function (fieldClass) {
				var $field = address.find('.' + fieldClass);
				var fieldValue = $field.text();

				// if the field contains a link, we take the link href
				if ($field.find('[href]').length > 0) {
					fieldValue = $field.find('[href]').attr('href');
				}

				elementIndexObject[fieldClass] = fieldValue;

				return false;
			});

			_this2.lunrIndex.add(elementIndexObject);
		});
	},


	/**
  * Show the initial number of visible items
  *
  * @returns {void}
  */
	showInitialSelection: function showInitialSelection() {
		this.$addresses.hide();
		this.$addresses.slice(0, this.initialVisibleItems).show();

		this.maxShownCount = this.initialVisibleItems;

		this.updateResultCount(this.$addresses.length);

		if (this.$addresses.length <= this.maxShownCount) {
			this.$button.hide();
		} else {
			this.$button.show();
		}
	},


	/**
  * Update the result text depending on the number of items
  *
  * @param {number} resultCount The result count
  * @returns {void}
  */
	updateResultCount: function updateResultCount(resultCount) {
		this.$resultCount.text(resultCount);

		if (resultCount === 1) {
			this.$resultText.text(this.resultTextSingular);
		} else {
			this.$resultText.text(this.resultTextPlural);
		}
	},


	/**
  * Event when the user clicked on the show more button, show more is done by un-hiding more elements visually
  *
  * @returns {void}
  */
	onClickMoreButton: function onClickMoreButton() {
		this.maxShownCount = this.maxShownCount + this.loadMoreItems;

		this.$addresses.slice(0, this.maxShownCount).show();

		if (this.$addresses.length <= this.maxShownCount) {
			this.$button.hide();
		}
	},


	/**
  * Event when the user searched the displayed items via fulltext search
  * Please note: The real filtering happens via page reload
  *
  * @param {string} value The value to search for
  * @returns {void}
  */
	onFilterChange: function onFilterChange(value) {
		var _this3 = this;

		if (value.length < 3) {
			if (value.length === 0) {
				this.showInitialSelection();

				this._events.emit(this._eventNames.filterMapData, {
					showAll: true
				});
			}
			return;
		}

		var results = this.lunrIndex.search(value);
		var visibleResults = [];

		this.maxShownCount = results.length + 1;
		this.$addresses.hide();

		this.$button.hide();

		results.map(function (addressStoreObject) {
			visibleResults.push(addressStoreObject.ref);
			return _this3.$ctx.find('#' + addressStoreObject.ref.trim()).show();
		});

		this.updateResultCount(visibleResults.length);

		this._events.emit(this._eventNames.filterMapData, {
			visibleResults: visibleResults
		});
	},


	/**
  * Event when the search get's closed, show the initial selection
  *
  * @returns {void}
  */
	onSearchClosed: function onSearchClosed() {
		this.showInitialSelection();

		this._events.emit(this._eventNames.filterMapData, {
			showAll: true
		});
	}
});